export default {"src":"/_next/static/media/auction.a7b8ffc4.svg","height":90,"width":89};